module.exports = __webpack_public_path__ + "static/media/7-item-d.183eeb34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/7-item-d.jpg
// module id = 1209
// module chunks = 33